import React from 'react';
import { IconButton, SearchIcon } from 'evergreen-ui';

/**
 * @param {boolean} isChangedSearchParams true - зеленая кнопка, false - обычная
 */
export const SearchButton = React.memo(({
  isChangedSearchParams,
  ...buttonProps
}) => (
  <IconButton
    {...buttonProps}
    icon={SearchIcon}
    appearance={isChangedSearchParams ? 'primary' : 'default'}
    intent={isChangedSearchParams ? 'success' : 'none'}
  />
));
SearchButton.displayName = 'SearchButton';
